import React from "react";
import { CardImage } from "./CardImage";
import { CardContent } from "./CardContent";
import { useDesignerCardState } from "./useDesignerCardState";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from "@/hooks/domains/auth/useAuth";
import { formatLocation } from '@/lib/utils';

interface DesignerCardProps {
  id: string;
  name: string;
  title: string;
  location: string;
  imageSrc: string;
  viewCount: number;
  likeCount: number;
  isLiked: boolean;
  skills?: string[];
  username_slug?: string | null;
  className?: string; // Add className prop
  hire_me_enabled?: boolean;
  is_featured?: boolean;
}

const DesignerCard = ({
  id,
  name,
  title,
  location,
  imageSrc,
  viewCount,
  likeCount,
  isLiked,
  skills = [],
  username_slug,
  className = "", // Add className with empty string default
  hire_me_enabled = false,
  is_featured = false,
}: DesignerCardProps) => {
  const isMobile = useIsMobile();
  const { user } = useAuth();

  const {
    likeState,
    likeCount: displayLikeCount,
    handleLikeToggle,
    isLoading: isLiking,
    profilePath,
    isHovered,
    setIsHovered,
  } = useDesignerCardState({
    id,
    isLiked,
    likeCount,
    username_slug,
    user,
  });

  // Capitalize location in title case (each word)
  const formattedLocation = location ? formatLocation(location) : location;

  return (
    <div
      className={`relative group rounded-lg overflow-hidden border shadow-sm dark:border-gray-800 transition-all hover:shadow-md ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <a href={profilePath} className="block">
        <CardImage
          imageSrc={imageSrc}
          name={name}
          displayDiscipline={title}
          location={formattedLocation}
          isLiked={likeState}
          isHovered={isHovered}
          isFeatured={is_featured}
          onLike={handleLikeToggle}
          isLiking={isLiking}
          isMobile={isMobile}
          hire_me_enabled={hire_me_enabled}
        />
      </a>

      <CardContent
        name={name}
        title={title}
        location={formattedLocation}
        likeCount={displayLikeCount}
        viewCount={viewCount}
        isLiked={likeState}
        skills={skills}
        profilePath={profilePath}
        isMobile={isMobile}
        hire_me_enabled={hire_me_enabled}
        is_featured={is_featured}
        onLikeToggle={handleLikeToggle}
      />
    </div>
  );
};

export default DesignerCard;
